module.exports = __webpack_public_path__ + "img/28_4.18ac67b6.png";